export const highlightError = (
  field,
  msg = "This field is required",
  fontSize
) => {
  //create error highlight elem
  const errorElement = document.createElement("span");
  errorElement.setAttribute("name", "validationMsg");
  errorElement.classList.add("text-danger");
  errorElement.style.fontSize = fontSize ? `${fontSize}px` : "9px";
  errorElement.innerHTML = msg;

  if (field.type === "file") {
    field.parentNode.classList.add("border-danger");

    field.parentNode.onclick = () => {
      errorElement.remove();
      field.parentNode.classList.remove("border-danger");
    };

    field.parentNode.parentNode.insertBefore(
      errorElement,
      field.parentNode.nextSibling
    );
  } else {
    field.classList.add("border-danger");

    field.onclick = () => {
      errorElement.remove();
      field.classList.remove("border-danger");
    };
    field.parentNode.insertBefore(errorElement, field.nextSibling);
  }

  setTimeout(
    () => field.scrollIntoView({ behavior: "smooth", block: "center" }),
    100
  );
};

export const normalizeId = (id = "") => {
  return id
    .toLowerCase()
    .trim()
    .replace(/ /g, "");
};
export const getDateWithTimezone = (dateString) => {
  try {
    return new Date(dateString.split("-").join("/")).toISOString();
  } catch (e) {}
};

export const setAttribute = (formsJson, fieldId = "", key, value) => {
  const forms = formsJson["forms"];

  let found = false;

  if (forms) {
    for (const form of forms) {
      for (const row of form.rows) {
        for (const col of row.columns) {
          const field = col.field;
          if (field.id === fieldId) {
            //found
            field[key] = value;
            found = true;
            break;
          }
        }
        if (found) break;
      }

      if (found) break;
    }
  }
};

export const removeHighlightedError = (elementName) => {
  const elements = document.getElementsByName(elementName);
  elements.forEach((element) => {
    element.parentNode.removeChild(element);
  });
};

export const validateInputExtra = (input) => {
  const type = input.type;
  const value = input.value;

  let valid = true;
  let msg = "";

  if (type === "email") {
    valid = validateEmail(value);
    if (!valid) msg = "Please provide a valid email address";
  }

  return { valid, msg };
};

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const getFormattedDate = (date) => {
  var dd = date.getDate();
  var mm = date.getMonth() + 1; //January is 0!
  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }

  return yyyy + "-" + mm + "-" + dd;
};
export const addOrUpdateItemInArray = (array, object, pk = "_id") => {
  const arrayCopy = [...array];
  const indexInArray = arrayCopy.findIndex((item) => {
    if (Array.isArray(item[pk]) && Array.isArray(object[pk])) {
      // Compare arrays by checking if their lengths are equal and their elements match
      return (
        item[pk].length === object[pk].length &&
        item[pk].every((value, index) => value === object[pk][index])
      );
    } else {
      // For non-array values, perform regular strict equality check
      return item[pk] === object[pk];
    }
  });

  if (indexInArray === -1) {
    arrayCopy.unshift(object);
  } else {
    arrayCopy[indexInArray] = object;
  }

  return arrayCopy;
};
export function isValidLongitudeOrLatitude(value) {
  const validRegex = /^-?\d+(\.\d+)?$/;
  const isValid = value === "-" || validRegex.test(value);
  return isValid;
}
